import React, {Component} from 'react';
import {connect} from "react-redux";
import * as actions from "../../../../../../actions";
import NewChatSearch from "../../../../../../components/messaging/new-chat-search";
import NewChatUserListItem from "../../../../../../components/messaging/new-chat-user-list-item";
import {Container} from "reactstrap";
import api from "../../../../../../util/messaging/api";
import "./index.css";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "react-loading-animation";

class NewChatUserList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,

            query: '',
            type: 'all',
            userList: []
        }

    }

    componentDidMount() {
        api.getUserList(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //this will be called for every pagination we perform
        if (nextProps.get_all_users && nextProps.get_all_users.payload !== this.props.get_all_users.payload) {

            if (nextProps.get_all_users.payload &&
                nextProps.get_all_users.payload.hasOwnProperty("data") &&
                nextProps.get_all_users.payload.data.hasOwnProperty("data")) {

                let data = nextProps.get_all_users.payload.data;
                let userList = data.data;

                if (this.state.currentPage !== 1) {
                    if (userList.length > 0) {
                        userList = this.state.userList.concat(nextProps.get_all_users.payload.data.data)
                    } else {
                        userList = this.state.userList;
                    }
                }

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) <= parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * data.data.length,
                    totalItems: parseInt(data.total),
                    userList,
                    reset: false
                }, () => {
                    if (this.state.hasMore && this.state.currentPage < 3) {
                        this.loadNextPage();
                    }
                })
            }
        }

        if (nextProps.type !== this.state.type) {
            this.setState({
                type: nextProps.type
            },()=>{
                console.log("updating.... >> this.state.type = "+this.state.type)
                this.reloadUserList(this.state.query,this.state.type)
            })
        }
    }

    loadNextPage = () => {

        console.log("loadNextPage",{
            hasMore:this.state.hasMore,
            currentPage:this.state.currentPage
        });

        if (this.state.hasMore) {
            let currentPage = this.state.currentPage;
            currentPage = currentPage + 1;

            this.setState({
                currentPage
            }, () => {
                api.getUserList(this.props, this.state.query, this.state.type, this.state.currentPage);
            })
        }
    }

    reloadUserList = (query = '',type = 'all') => {
        this.setState({
            query: query,
            type: type,
            reset: true,
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
        }, () => {
            //refresh the page
            api.getUserList(this.props, this.state.query, this.state.type, this.state.currentPage);
        })
    }

    render() {
        return (
            <Container className="no-padding">
                <NewChatSearch
                    search={(searchText) => {
                        console.log("NewChatSearch >> searchText = " + searchText)
                        this.reloadUserList(searchText,this.state.type)
                    }}/>


                <InfiniteScroll
                    className="user-list-infinite-scroll-component"
                    height={400}
                    dataLength={this.state.userList.length}
                    next={this.loadNextPage}
                    hasMore={this.state.hasMore}
                    loader={<Loading/>}
                    endMessage={<span/>}>

                    {
                        this.state.userList.map((item, index) => {
                            return (
                                <NewChatUserListItem
                                    type={this.state.type}
                                    key={`new-chat-user-list-item-${index}`}
                                    item={item}
                                    profile_pic={item.profile_pic}
                                    status={item.status}
                                    username={item.username}
                                    action={(item) => {
                                        console.log("NewChatUserList >> clicked on username", item)
                                        this.props.userSelectedFromNewChatList(this.state.type, item)
                                    }}
                                />
                            )
                        })
                    }

                </InfiniteScroll>

            </Container>
        );
    }
}

NewChatUserList.propTypes = {};

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        get_all_users: state.get_all_users,
        flag: state.flag
    };
}

export default connect(mapStateToProps, actions)(NewChatUserList);
